enum SiteToolsTestIds {
	dropdownProfileDetails = 'site-tools-profile-details-dropdown',
	dropdownManageOfficeUsers = 'site-tools-manage-office-users-dropdown',
	dropdownChangePassword = 'site-tools-change-password-dropdown',
	dropdownLogout = 'site-tools-logout-dropdown',
	dropdownList = 'site-tools-dropdown-list',
	siteToolsUserDetailsDropdownContainer = 'site-tools-user-details-dropdown-container',
}

export default SiteToolsTestIds;
